import React from 'react';
import { withHandlers } from 'recompose';
import cx from 'classnames';

import styles from './styles.css';

export default withHandlers<any, any>({
  onSubmit:
    ({ handleSubmit, onSubmit }) =>
    (...args) => {
      if (args[0] && args[0].preventDefault) args[0].preventDefault();
      if (handleSubmit) return handleSubmit(...args);
      if (onSubmit) return onSubmit(...args);
    },
})(({ children, className, onSubmit, error }: any) => (
  <form
    className={cx(styles.root, error && styles.hasError, className)}
    onSubmit={onSubmit}
  >
    {error && <div className={cx(styles.message, styles.error)}>{error}</div>}
    {children}
  </form>
));
